/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  createAndAssignLabel(conversationID, label) {
    return axios.post(
      `${this.url}/${conversationID}/labels/create_and_assign`,
      { label }
    );
  }
}

export default new ConversationApi();
